<template>
  <footer class="footer">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-6">
          {{ footerCopyRight }}
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  data() {
    return {
    }
  },
  computed: {
    curEnv() {
      return process.env.VUE_APP_MODE
    },
    footerCopyRight() {
      switch(this.curEnv){
        case 'gk':
          return ''
        case 'scnu':
          return 'Copyright © 2023 South China Normal University.All Rights Reserved'
        default:
          return ''
      }


    },
  },
  mounted() {},
  methods: {
    getFooter() {},
  },
}
</script>
<style lang="scss" scoped></style>
